import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph,
  Heading1,
  Heading2,
  List,
  LinkStyled,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Pilsner">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Pilsner</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            Pilsner på fad er en skøn tørstslukker på de lune sommerdage eller til festen. En pilsner kendetegnes ved sin lyse farve og oftest friske smag og derfor egner den sig særligt godt til fx frokostbordet. Her på siden finder du vores store udvalg af udenlansk og dansk pilsner på fad, herunder de velkendte Grøn Tuborg og Carlsberg Pilsner, men også andre pilsner øl fra bl.a. Royal, Heineken, Paulaner, Herslev Bryghus og Nørrebro Bryghus.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelPilsner" filterLiterPrice filterFadkobling filterLiterSize display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Pilsner på fad</Heading2>
          <Paragraph>
            Når du nyder en pilsner fra fadølsanlægget, kan du vide dig sikker på at du får en vaskeægte tørstslukker. En pilsner har oftest en skøn afrundet sødme og en frisk bitterhed fra humlen, hvilket gør den let at drikke og endnu lettere at nyde. Derfor er en pilsner også en velkendt øltype, der er elsket i mange hjem og populær til arrangementer.
          </Paragraph>
          <Paragraph>
            Hos Skafte forhandler vi et bredt udvalg af udsøgte pilsner øl på fad. Har du brug for at <LinkStyled to="/fadoelsanlaeg">leje et fadølsanlæg</LinkStyled> til dit næste arrangement, hvor der serveres pilsner eller anden øl? Vi udlejer også fadølsanlæg til både privat og erhverv, så du har mulighed for at skænke dine gæster en iskold og forfriskende pilsner direkte fra hanen og fustagen.
          </Paragraph>
          <Paragraph>
            Vores udvalg af pilsner leveres som udgangspunkt i en fustage af enten 20, 25 eller 30 liter og har en type S fustage tilkobling. Dette betyder, at fustagerne med pilsner passer til de fleste og mest normale typer af fadølsanlæg. Hvis du bestiller en eller flere fustager med pilsner inklusiv leje af anlæg, sørger vi naturligvis for at tilkoblingen matcher.
          </Paragraph>
          <Paragraph>
            Gå på opdagelse i vores store udvalg af pilsner på fad. Her på siden finder du mange forskellige varianter, herunder en masse skønne danske pilsnere, både klassikere som mindre velkendte.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Kendetegnene for en pilsner</Heading2>
          <Paragraph>
            Inden vi dykker helt ned i kendetegnene for en pilsner samt dens karaktertræk, vil vi slå et lille slag for historien bag pilsner øllen. Man kan nemlig ikke komme udenom, at historien spiller en væsentlig rolle for øllets udbredelse og den skønne smag som vi kender i dag.
          </Paragraph>
          <Paragraph>
            En pilsner er en undergæret øl, der har sin oprindelse tilbage i 1842 i Tjekkiet, nærmere bestemt i Plzeň (udtales Pilsen). Byen har naturligvis også lagt navn til netop denne type øl. Tidligere havde man kun kunnet få overgæret øl, men i takt med industrialiseringen, var det nu også muligt at producere en undergæret øl og en pilsner var altså den første af sin slags i verden.
            Teknikken blev hurtigt udbredt til resten af Tjekkiet og senere resten af verden. Den første danske pilsner så dagens lys i 1881, hvor den blev produceret af Tuborg. Siden hen er en dansk pilsner blevet så udbredt, at der findes en variant hos de fleste bryghuse.
          </Paragraph>
          <Paragraph>
            Kendetegnene ved en pilsner er først og fremmest den lyse gyldne farve samt dens alkoholprocent. En pilsner har oftest en alkoholprocent omkring 5%.
            Pilsneren er en undergæret øl og er i dag en af de mest velkendte øltyper blandt danske øldrikkere. Ligesom alle andre øl vil smagen naturligvis variere og afhænger af bryghuset, bryggeren og opskriften.
          </Paragraph>
          <Paragraph>
            I en pilsner mødes man ofte af:
          </Paragraph>
          <List>
            <li>Lys gylden farve</li>
            <li>Afrundet sødme</li>
            <li>Frisk bitterhed</li>
            <li>Skøn og mild aroma fra humlen</li>
            <li>God balance mellem bitter humle og aromatisk humle</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Stort udvalg af skøn dansk pilsner</Heading2>
          <Paragraph>
            De danske pilsner øl er yderst populære - og med god grund. De er nemlig alle gode tørstslukkere og har en skøn og velbalanceret smag.
          </Paragraph>
          <Paragraph>
            Hos Skafte finder du mange dejlige danske pilsner øl, herunder:
          </Paragraph>
          <List>
            <li>Grøn Tuborg</li>
            <li>Royal Pilsner</li>
            <li>Carlsberg Pilsner (også kendt som HOF)</li>
            <li>Albani Odense Pilsner</li>
            <li>Thor Pilsner</li>
            <li>Herslev Bryghus Øko Pilsner</li>
            <li>Nørrebro Bryghus Øko Pilsner</li>
            <li>Royal Øko Pilsner</li>
            <li>Tuborg Øko Rå</li>
            <li>Tuborg Guld</li>
            <li>Hornbeer Øko Godt Øl</li>
            <li>Skovlyst Birkebryg</li>
          </List>
          <Paragraph>
            Dette er blot et udsnit af de mange skønne varianter af dansk pilsner, som du finder på fad her hos Skafte.
          </Paragraph>
          <Paragraph>
            Er du interesseret i at læse mere om hver enkelte danske pilsner og dens specielle karakteristika og smag? Så klik ind på hver øls respektive side, hvor du kan læse meget mere om smag og historie samt se alle informationer om øllen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Prøv også en spændende udenlandsk pilsner</Heading2>
          <Paragraph>
            Man går aldrig galt i byen med en lækker dansk pilsner, men de udenlandske producenter gør det altså også rigtig godt. Hos Skafte finder du naturligvis også et bredt udvalg af velsmagende pilsner fra hele verden.
          </Paragraph>
          <Paragraph>
            Du kan bl.a. finde udenlandsk pilsner som:
          </Paragraph>
          <List>
            <li>San Miguel Especial</li>
            <li>Stella Artois</li>
            <li>Budweiser</li>
            <li>Heineken</li>
            <li>Platan Pilsner</li>
            <li>Paulaner Oktoberfest Øl</li>
            <li>Lobkowicz Tmavy</li>
          </List>
          <Paragraph>
            Gennem en af disse pilsnere, kan du smage dig gennem mange andre landes (og producenters) bud på, hvordan de synes en pilsner bør være. Tag et smut til Spanien med San Miguel Especial, hvor du mødes af en lidt højere alkoholprocent og hvor smagen er kraftig, men stadig let og frisk. Du kan også få den velkendte Heineken pilsner fra Holland - en øl, som størstedelen af verden kender og elsker.
          </Paragraph>
          <Paragraph>
            Hvis vi bevæger os over Atlanten, kan du smage på det amerikanske bud på en pilsner, nemlig Budweiser. Smagen er frisk og sprød, og faktisk er hver femte solgte øl i USA en Budweiser pilsner.
          </Paragraph>
          <Paragraph>
            Hvis du ønsker at smage en pilsner, der adskiller sig fra alle andre, bør du prøve Lobkowicz Tmavy. Her er der tale om en sort pilsner, hvor smagen byder på nuancer af både lakrids og kaffe.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Nyd din pilsner på fad - Skafte udlejer også fadølsanlæg og udstyr</Heading2>
          <Paragraph>
            Det er altid skønt at nyde en pilsner på fad og det er ofte en del af oplevelsen, når pilsneren skænkes, hvorefter du lader den lyse, gyldne væske slukke tørsten og den efterlader en hvid skum på overlæben.
          </Paragraph>
          <Paragraph>
            Hos Skafte kan du leje fadølsanlæg og udstyr til både privat og erhverv. Et fadølsanlæg giver festen eller arrangementet et ekstra løft, så hvorfor ikke forkæle dine gæster eller kunder med en dejlig, iskold og frisk skænket pilsner fra fad?
            Vi kan levere både fustager med pilsner og fadølsanlæg med forholdsvis kort varsel. Ønsker du en garanti for et ledigt fadølsanlæg, så bestil blot mindst en uge i forvejen for festen eller arrangementet.
          </Paragraph>
          <Paragraph>
            Når du bestiller et anlæg samt fustager, behøver du kun at betale for de åbne fustager. Dette betyder, at du kan returnere de uåbnede fustager med pilsner, hvis du skulle have bestilt for meget.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
